module.exports = __webpack_public_path__ + "media/stylesheets/images/media/userway_function_icons/icn-feature-04-036d22b0049804508791770c0181d6d5.svg";